import React from "react";

import SingleImg05 from "./../assets/AyurvedaAssets/images/single-img-05.png";
import SingleImg01 from "./../assets/AyurvedaAssets/images/single-img-01.jpg";

export default function OurCenters() {
  const wellnessCenters = [
    {
      id: 1,
      name: "Bharat Dhara Wellness Center - Khatauli",
      city: "Khatauli",
      state: "Uttar Pradesh",
      address: "B-107 Awas Vikas Colony, District Muzaffar Nagar, U.P.",
      phone: "+91-7060112355",
      image: SingleImg01,
      description:
        "Khatauli Center blends classical Ayurveda with nature—offering traditional Panchakarma therapies, personalized consultations, and daily yoga practices to restore balance and vitality.",
    },
     ];

  return (
    <div className="site-main">
      {/* Page Title */}
      <div className="prt-page-title-row">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="page-title-heading">
                    <h2 className="title">Our Yoga Centers</h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <a title="Homepage" href="index-2.html">
                        Home
                      </a>
                    </span>
                    <span>Centers & Camps</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="d-block container m-auto py-5 my-5">
        <div className="">
          <h2 className="text-center">
            BD's Wellness Centers & Upcoming Camps
          </h2>
          <section class="max-w-5xl mx-auto px-4 py-10">
            <p class="mt-6 text-lg leading-8 text-slate-700">
              Bharat Dhara Wellness Centers, located across India, are dedicated
              to restoring balance and harmony through the timeless wisdom of
              Ayurveda. Each center offers personalized Ayurvedic consultations,
              authentic herbal treatments, and natural therapies designed to
              heal the body, mind, and spirit. With a team of experienced
              Ayurvedic doctors and therapists, Bharat Dhara provides holistic
              solutions for chronic ailments, lifestyle disorders, stress, and
              overall wellness. Using the finest Ayurvedic medicines and
              traditional healing techniques, we help patients achieve
              long-lasting health and inner tranquility—the natural way.
              Rediscover wellness with Bharat Dhara—where ancient science meets
              modern care, and every treatment is rooted in authenticity and
              compassion. We also organize Ayurveda awareness camps across India
              to promote ancient wisdom and the development of a holistic way of
              life (samagra jivan shaili vikas).{" "}
              <strong>Please see our upcoming camp details below.</strong>
            </p>

            <div class="mt-8 rounded-2xl border border-emerald-200 p-5 bg-emerald-50">
              <h3 class="text-2xl font-semibold text-emerald-900">
                Upcoming Ayurveda Shivir
              </h3>
              <p
                lang="hi"
                class="mt-4 text-lg leading-8 text-black dark:text-white"
              >
                हम भारतभर में <strong>आयुर्वेद जागरूकता शिविर</strong> आयोजित
                करते हैं—प्राचीन ज्ञान एवं{" "}
                <strong>समग्र जीवन शैली विकास</strong> (समग्र जीवन शैली विकास)
                को बढ़ावा देने के लिए।
                <strong> कृपया नीचे हमारे आगामी शिविर का विवरण देखें।</strong>
              </p>
              <p class="mt-2 text-slate-800">
                4 - 6 November 2025 • Jaipur • 9:00 AM–5:00 PM • Registration
                TBD • Consultations, basic diagnostics, Panchakarma previews,
                Therapies, Ayurvedic Medicine and Bharat Dhara Natural products
                showcase • 10-day follow-up valid at Khatauli Center
              </p>
              <div class="mt-4 flex gap-3">
                <a
                  href="/register"
                  class="inline-flex items-center rounded-xl px-5 py-2.5 font-medium border border-emerald-600 text-emerald-700 hover:bg-emerald-600 hover:text-white transition"
                >
                  Register Now
                </a>
                <a
                  href="/Centers-and-Camps#schedule"
                  class="inline-flex items-center rounded-xl px-5 py-2.5 font-medium border border-slate-300 text-slate-700 hover:bg-slate-100 transition"
                >
                  View Schedule
                </a>
              </div>
            </div>
          </section>
        </div>
        <div className="row">
          <div className="col-md-4 col-lg-4">
            <h4 className="text-center">Filters</h4>
          </div>
          <div className="col-md-8 col-lg-8">
            <h4 className="text-center">Center's Listing</h4>
            <div className="row g-4">
              {wellnessCenters.map((center) => (
                <div className="col-12 col-md-12 col-lg-12" key={center.id}>
                  <div className="card h-100 shadow-sm border-0">
                    <img
                      src={center.image}
                      alt={center.name}
                      className="card-img-top"
                      style={{ height: "220px", objectFit: "cover" }}
                    />
                    <div className="card-body">
                      <h5 className="card-title text-success">{center.name}</h5>
                      <p className="card-text text-muted small">
                        <i className="bi bi-geo-alt-fill text-danger me-2"></i>
                        {center.address}
                      </p>
                      <p className="card-text">{center.description}</p>
                      <p className="fw-bold text-dark mb-1">
                        <i className="bi bi-telephone-fill text-success me-2"></i>
                        {center.phone}
                      </p>
                      <p className="text-secondary mb-0">
                        <i className="bi bi-map text-primary me-2"></i>
                        {center.city}, {center.state}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* cta-section */}
      <section className="prt-row padding_zero-section cta-section03 animation clearfix">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="cta-content text-center">
                <div className="section-title title-style-center_text">
                  <div className="title-header">
                    <h2 className="cta-title">Need a help</h2>
                    <h3 className="cta-titlepre">
                      Are you facing any problem in your health?
                    </h3>
                  </div>
                  <div className="cta-bnt mt-40 fadeup-amin">
                    <a
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-darkcolor"
                      href="contact-us.html"
                    >
                      Contact us now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div
                className="prt_single_image-wrapper cta-img mt-40 res-991-mt-20"
                data-cursor-tooltip=""
              >
                <div className="prt_single_image-wrapper">
                  <a href="team-details.html">
                    <img
                      width="1920"
                      height="400"
                      className="img-fluid"
                      src={SingleImg05}
                      alt="image"
                    />
                  </a>
                </div>
                <div className="prt-pfbox-overlay">
                  <div className="ctaimg-title">
                    <a href="team-details.html">Meet our Bharat Dhara Privar</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* cta-section end */}

      {/* info-section */}
      <section className="prt-row padding_zero-section prt-bg bg-base-skin info-section clearfix">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-md-12">
              <div className="prt-info-main-block">
                <div className="info_btn mr-30 res-767-mb-15">
                  <a
                    className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                    href="#"
                  >
                    COVID-19 resources
                  </a>
                </div>

                {/* featured-icon-box */}
                <div className="featured-icon-box icon-align-before-content style2">
                  <div className="featured-icon">
                    <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                      <i className="flaticon-alert"></i>
                    </div>
                  </div>
                  <div className="featured-content">
                    <div className="featured-title">
                      <h3>Get The Health package</h3>
                    </div>
                    <div className="featured-desc">
                      <p>
                        What you need to know about the 2019 - 2023 fly season.
                      </p>
                    </div>
                  </div>
                </div>
                {/* featured-icon-box end */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* info-section end */}
    </div>
  );
}
